<template>
    <v-dialog
        v-model="dialogShown"
        max-width="300px"
        persistent
        scrollable>
        <v-card>
            <v-card-title class="justify-center">
                {{title}}
            </v-card-title>
            <v-card-text class="text-center">
                <v-container>
                    <v-row>
                        {{message}}
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="secondary" @click="onNo">{{$t('no')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="onYes">{{$t('yes')}}</v-btn>    
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
    import {ref,watch} from "@vue/composition-api";

    export default {
        name: 'PopupAlert',
        props:{
            title: String,
            message: String,
            onYes: Function,
            onNo: Function,
            value: Boolean
        },
        setup(props){
            
            const dialogShown = ref(Boolean(props.value))

            watch(()=> props.value, (newValue,oldValue)=>{
                if(newValue!=null && newValue!==oldValue){
                    dialogShown.value = newValue
                }
            })
            
            return {
                dialogShown
            }
        }


    }
</script>